import type { AccountGetResponse, MLSID } from '@aloft/toolkit-shared';
import { initialFTUXDictionary, isUndefined } from '@aloft/toolkit-shared';

import type { RootState } from '../types.ts';

export const accountReqToState = (accountReq: AccountGetResponse): RootState['account'] => {
  const { id, email, body, userType, isAdmin } = accountReq;
  const { firstName, lastName, phone, mlsIDs, isOnboardingComplete, ftux, signatureBlobId } = body;

  return {
    id,
    email,
    firstName,
    lastName,
    phone,
    mlsIDs: (mlsIDs ?? []) as MLSID[],
    isOnboardingComplete: isUndefined(isOnboardingComplete) ? true : isOnboardingComplete,
    ftux: ftux ?? initialFTUXDictionary,
    signatureBlobId,
    userType,
    isAdmin,
  };
};
